/** Change dataset format for echarts from object to array and schema */
export function changeDatasetSourceFormat(dataset: any) {
    // if 'source' not exists, then return
    if (!dataset.source) {
        return dataset;
    }
    const dimensions: any = [];
    const source: any = [];
    for (const key in dataset.source[0]) {
        dimensions.push(key);
    }
    for (const item of dataset.source) {
        const row: any = [];
        for (const key of dimensions) {
            row.push(item[key]);
        }
        source.push(row);
    }
    dataset = { ...dataset, source, dimensions };
    return dataset;
}
